module.exports = __webpack_public_path__ + "static/collabwithusnavbariconmobile-313550fe5df0954fd419fac1e03e5383.png";